import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'communication-preference-questiontype',
  templateUrl: './communicationpref.questiontype.component.html'
})
export class CommunicationPreferenceComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  formError:false;
  value:any;
  formSegment:FormGroup;

  constructor() {
    this.value={
      "email":false,
      "text":false
    };
  }
  isValid():boolean {
    return true;
  }
  validate():boolean {
    return true;
  }

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  ngOnInit() {
    var i,init={};
    init['email']=new FormControl();
    init['text']=new FormControl();

    this.formSegment=new FormGroup(init);

    if(((typeof this.value)==='object') && (this.value !== null)) {
      for(i in init) {
        if(this.value.hasOwnProperty(i)) {
          init[i].setValue(this.value[i]);
        }
      }
    }
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/communicationpref.questiontype.component.ts